(function () {
    'use strict';
    angular
            .module('imnApp')
            .controller('PacketRuleAddController', PacketRuleAddController);

    PacketRuleAddController.$inject = ['$scope', '$state', '$rootScope', '$filter', '$uibModalInstance', '$translate', 'PacketRuleService', 'OltService', 'packetRuleId'];

    function PacketRuleAddController($scope, $state, $rootScope, $filter, $uibModalInstance, $translate, PacketRuleService, OltService, packetRuleId) {

        // Variables
        var vm = this;
        vm.requestRunning = false;
        vm.arrayOlts = null;
        vm.arrayGroups = null;
        vm.arrayTypes = null;
        vm.typeList = null;
        vm.isEdit = !!packetRuleId;
        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.labelButton = vm.isEdit ? 'save' : 'add';
        vm.values = null;
        vm.groupDisabled = true;

        vm.oltRules = {
            OLT8820G: {
                max: 2147483647
            },
            Intelbras8820i: {
                max: 32
            }
        }

        vm.packetRuleModel = {
            id: '',
            olt: '',
            group: '',
            newGroup: {value: '', tooltip: ''},
            name: '',
            member: {value: '', tooltip: ''},
            type: '',
            values: []
        }

        // Methods Handler
        vm.changeOlt = changeOlt;
        vm.changeGroup = changeGroup;
        vm.changeType = changeType;
        vm.close = close;
        vm.save = save;

        // Method API
        function getAllOlt() {
            if (!vm.isEdit) {
                vm.requestRunning = true;
                OltService.getOlt().then(successOlt).catch(errorOlt);
            }
        }

        function isEdit() {
            if (vm.isEdit) {
                vm.requestRunning = true;
                PacketRuleService.getPacketRule(packetRuleId).then(successPacketRules).catch(errorPacketRules);
            }
        }

        // Methods Handler
        function changeOlt(olt) {
            vm.requestRunning = true;
            if (!vm.isEdit) {
                var oltRule = vm.oltRules[olt.model];
                vm.packetRuleModel.member.max = oltRule.max;
                vm.packetRuleModel.newGroup.max = oltRule.max;
                $translate('tooltip.packetRuleGroupValue', oltRule).then(setTooltip('newGroup'));
                $translate('tooltip.packetRuleMemberValue', oltRule).then(setTooltip('member'));
                PacketRuleService.listGroups(olt.id).then(successGroup).catch(errorGroup);
                cleanFields();
            }
            PacketRuleService.listTypes(olt.id).then(successType).catch(errorType);
        }

        function setTooltip(input) {
            return function (translation) {
                vm.packetRuleModel[input].tooltip = translation;
            }
        }

        function changeGroup() {
            vm.groupDisabled = !!vm.packetRuleModel.group.id;
        }

        function changeType(type) {
            vm.packetRuleModel.values = {};
            vm.values = type.values;
        }

        function getTypeList() {
            PacketRuleService.getTypeList().then(function (data) {
                vm.typeList = data;
            });
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function cleanFields() {
            vm.packetRuleModel.group = '';
            vm.packetRuleModel.member.value = '';
            vm.packetRuleModel.type = '';
            vm.groupDisabled = true;
            vm.packetRuleModel.newGroup.value = '';
        }

        function save() {
            if (vm.formPacketRuleAdd.$valid && !vm.requestRunning) {
                var data = {
                    name: vm.packetRuleModel.name.toUpperCase(),
                    member: vm.packetRuleModel.member.value,
                    type: vm.packetRuleModel.type.value,
                    values: []
                };

                for (var key in vm.packetRuleModel.values) {
                    data.values.push({
                        name: key,
                        value: vm.packetRuleModel.values[key]
                    });
                }

                if (!vm.isEdit) {
                    data.oltId = vm.packetRuleModel.olt.id;
                    if (vm.packetRuleModel.group.id == null) {
                        data.groupIdEquipment = vm.packetRuleModel.newGroup.value;
                    } else {
                        data.groupId = vm.packetRuleModel.group.id;
                    }
                } else {
                    data.id = vm.packetRuleModel.id;
                }

                vm.requestRunning = true;
                if (vm.isEdit) {
                    PacketRuleService.updatePacketRule(data).then(successSave).catch(errorSave);
                } else {
                    PacketRuleService.addPacketRule(data).then(successSave).catch(errorSave);
                }
            }
        }

        // Method response
        function successOlt(data) {
            var itens = [];
            vm.requestRunning = false;
            for (var i = 0; i < data.length; i++) {

                if (data[i].model != 'Intelbras8820i') {
                    itens.push(data[i]);
                    vm.arrayOlts = itens;

                }
            }
        }

        function errorOlt(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getOltList');
            close();
        }

        function successGroup(data) {
            vm.requestRunning = false;
            vm.arrayGroups = data;
            var newGroup = {
                id: null,
                groupIdEquipment: $filter('translate')('packetRule.modal.new')
            };
            vm.arrayGroups.push(newGroup);
        }

        function errorGroup(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getGroupList');
            close();
        }

        function successType(data) {
            vm.requestRunning = false;
            vm.arrayTypes = data.map(function (item) {
                var type = $filter('filter')(vm.typeList, {value: item.type}, true)[0];
                type.values = item.ruleValueNames;
                return type;
            });
        }

        function errorType(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getTypeList');
            close();
        }

        function successPacketRules(data) {
            vm.requestRunning = false;
            vm.packetRuleModel = angular.copy(data);
            vm.packetRuleModel.member = {value: data.member};
            vm.packetRuleModel.olt = {
                id: data.oltId,
                name: data.oltName
            };
            changeOlt(vm.packetRuleModel.olt);
            if (data.type) {
                vm.packetRuleModel.type = $filter('filter')(vm.typeList, {value: vm.packetRuleModel.type}, true)[0];
                vm.packetRuleModel.values = {};
                vm.values = data.values.map(function (item) {
                    vm.packetRuleModel.values[item.name] = item.value;
                    return item.name;
                });
            }
        }

        function errorPacketRules(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getPacketRule');
            close();
        }

        function successSave(data) {
            vm.requestRunning = false;
            var modalInstance = PacketRuleService.successModalConstructor('save');
            modalInstance.result.finally(function () {
                if (vm.isEdit) {
                    $rootScope.$emit('packetRuleUpdateSuccess', data);
                } else {
                    $rootScope.$emit('packetRuleAddSuccess', data);
                    $rootScope.$emit('cleanFilter');
                }
            });
        }

        function errorSave(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'save');
        }

        function initialize() {
            getTypeList();
            isEdit();
            getAllOlt();
        }

        initialize();
    }

})();
